<!-- Add new user for Test Dealer -->
<p-dialog
  [dismissableMask]="true"
  [(visible)]="addEditUserPopup"
  (onHide)="onHide()"
  [modal]="true"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false"
  [styleClass]="'addDealer-popup'"
  [closable]="false"
>
  <ng-template pTemplate="content">
    <div class="add-edit-user-form-wrapper">
      <form [formGroup]="addUserForm" (ngSubmit)="saveUser()">
        <div class="form-title">Add New User For {{ whoEntered.form }}</div>
        <div class="form-names-row">
          <div class="form-group">
            <label for="fname" class="form-label">Owner First Name</label>
            <input
              id="fname"
              type="text"
              formControlName="fname"
              class="form-control"
            />
            <app-form-errors
              [color]="'danger'"
              [form]="addUserForm"
              [control]="fname"
            ></app-form-errors>
          </div>
          <div class="form-group">
            <label for="lname" class="form-label">Owner Last Name</label>
            <input
              id="lname"
              type="text"
              formControlName="lname"
              class="form-control"
            />
            <app-form-errors
              [color]="'danger'"
              [form]="addUserForm"
              [control]="lname"
            ></app-form-errors>
          </div>
        </div>
        <div class="form-checkbox-row">
          <label class="checkbox-label">
            <input type="checkbox" formControlName="send_invitation" />
            <span>Send Invitation Via Email</span>
          </label>
        </div>
        <div class="form-group">
          <label for="email" class="form-label">Email</label>
          <input
            id="email"
            type="email"
            formControlName="email"
            class="form-control"
          />
          <app-form-errors
            [color]="'danger'"
            [form]="addUserForm"
            [control]="email"
          ></app-form-errors>
        </div>
        <div class="form-group">
          <label for="phone" class="form-label">Phone Number</label>
          <input
            id="phone"
            type="text"
            formControlName="phone"
            class="form-control"
            mask="(000) 000-0000"
            [validation]="true"
            [dropSpecialCharacters]="false"
          />
          <app-form-errors
            [color]="'danger'"
            [form]="addUserForm"
            [control]="addUserForm.controls['phone']"
          ></app-form-errors>
        </div>
        <div class="form-group form-notifications">
          <div class="form-label form-subtitle">Enable Notifications:</div>
          <div class="notification-toggle-row">
            <p-inputSwitch
              formControlName="enable_claim_creation_notification"
            ></p-inputSwitch>
            <label>Claim Creation</label>
          </div>
          <div class="notification-toggle-row">
            <p-inputSwitch
              formControlName="enable_claim_status_update_notification"
            ></p-inputSwitch>
            <label>Claim Status Update</label>
          </div>
        </div>
        <div *ngIf="!userId" class="form-group">
          <div class="form-label form-subtitle">Enable Navigation Tabs:</div>
          <div #permissions class="permissions-section">
            <div class="form-checkbox-group">
              <div *ngFor="let tab of navigationTabs" class="form-checkbox">
                <p-checkbox
                  [binary]="false"
                  [value]="tab.id"
                  formControlName="navigation_tab_ids"
                  [inputId]="'checkbox' + tab.id"
                ></p-checkbox>
                <label [for]="'checkbox' + tab.id">
                  {{ tab.name }}
                </label>
              </div>
            </div>
          </div>
          <div class="show-hide-btn" (click)="showHideSection()">
            <img src="./assets/images/ic-chevron.svg" alt="ic-chevron" />
          </div>
        </div>
        <div class="form-footer-row">
          <button type="button" class="cancel-btn" (click)="onHide()">
            Cancel
          </button>
          <button type="submit" class="send-btn" [disabled]="loadingSubmit">
            Send Now
          </button>
        </div>
      </form>
    </div>
  </ng-template>
</p-dialog>

<!-- confirmation message -->
<app-confirmation-msg
  class="conformation"
  #messageComponent
  [isLoading]="loadingConfirm"
  (accepted)="accepted()"
  (rejected)="rejected()"
  [headerMessage]="'Confirmation Message'"
  [bodyMessage]="'Are you sure you want to discard your data?'"
>
</app-confirmation-msg>
